import {
  Box,
  Button,
  Collapse,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import { excludeCheckBox, includeCheckBox } from "../../utils/NetworkHanlder";

export default function ConfigurableRow({
  data,
  config,
  removeGroupHandler,
  mainCalibrations,
  selectedOption,
  updateData,
}) {
  const [open, setOpen] = useState(false);
  const [checkBoxes, setCheckBoxes] = useState({});

  useEffect(() => {
    const initialState = data.components.reduce((acc, component) => {
      if (component?.deviceCalibration?.id) {
        acc[component.deviceCalibration.id] = component.isIncluded ?? false;
      }
      return acc;
    }, {});
    setCheckBoxes(initialState);
  }, [data]);

  useEffect(() => {
    setOpen(false);
  }, [selectedOption]);

  const colSpan = 6 + (config.mainRowCells?.length || 0);

  const handleCheckboxChange = async (componentId) => {
    const isCurrentlyChecked = checkBoxes[componentId];
    if (isCurrentlyChecked) {
      await excludeCheckBox(componentId);
    } else {
      await includeCheckBox(componentId);
    }

    setCheckBoxes((prevCheckBoxes) => ({
      ...prevCheckBoxes,
      [componentId]: !prevCheckBoxes[componentId],
    }));
    await updateData();
  };

  const checkCalibration = (calibrations, freq) => {
    if (calibrations === null) return "Brak Danych";

    const data = calibrations.filter((calibration) => {
      return calibration.freq === freq;
    })[0].appVolume;

    return data.length === 0 ? "Brak Danych" : data;
  };

  const renderProps = {
    mainCalibrations,
    removeGroupHandler,
    checkBoxes,
    handleCheckboxChange,
  };

  return (
    <>
      <TableRow>
        <TableCell>
          <IconButton size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>

        {config.mainRowCells.map((renderCell) => renderCell(data))}

        <TableCell>{checkCalibration(data.calibrations, 500)}</TableCell>
        <TableCell>{checkCalibration(data.calibrations, 1000)}</TableCell>
        <TableCell>{checkCalibration(data.calibrations, 2000)}</TableCell>
        <TableCell>{checkCalibration(data.calibrations, 4000)}</TableCell>

        <TableCell>
          <Button onClick={() => removeGroupHandler(data.id)}>Remove</Button>
        </TableCell>
      </TableRow>

      <TableRow>
        <TableCell
          style={{ paddingBottom: 0, paddingTop: 0 }}
          colSpan={colSpan}
        >
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Table>
                <TableHead>
                  <TableRow>
                    {config.collapsibleHeaders.map((header, index) => (
                      <TableCell key={index}>{header}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.components.map((component, index) => (
                    <TableRow key={"collapsibleRow_" + index}>
                      {config.collapsibleRowRender(
                        component,
                        index,
                        renderProps
                      )}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}
